export default "__VITE_ASSET__Dd0Z3g4B__"